<template>
  <div class="col-6 col-md-3 col-lg-3" v-if="team">
    <div class="team-content">
      <!-- team for desktop -->
      <div class="single-team d-none d-lg-block d-md-none d-sm-block">
        <img class="lazy" :data-src="team.profile_pic" alt="">
        <div class="team-footer">
          <p class="hf_heading06">{{ team.post_title }}</p>
          <p class="hf_bodytext02">{{ team.designation }}</p>
        </div>
        <div class="overlay title-overlay">
          <a href="javascript:void(0)" class="text-link" :data-team="team.post_id" data-bs-toggle="modal" :data-bs-target="'#exampleModal'+team.post_id">Know more</a>
        </div>
      </div>
      <!-- end team for desktop -->
      <!-- team for mobile -->
      <div class="sm-single-team d-block d-md-block d-sm-none d-lg-none">
        <div class="sm-image-container">
          <img class="lazy" :data-src="team.profile_pic" alt="">
          <div class="desc-link">
            <a href="javascript:void(0)" class="text-link" :data-team="team.post_id" data-bs-toggle="modal" :data-bs-target="'#exampleModal'+team.post_id">Know more</a>
          </div>
        </div>
        <div class="team-footer">
          <p class="hf_heading06">{{ team.post_title }}</p>
          <p class="hf_bodytext02">{{ team.designation }}</p>
        </div>
      </div>
      <!-- end team for mobile -->
    </div>
    <!-- FULL SCREEN MODAL -->
    <div class="modal fade ourTeam" :id="'exampleModal'+team.post_id" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div class="modal-body">
            <div class="expands-box">
              <div class="team-outer-container">
                <div class="container">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="button-container">
                        <a href="javascript:void(0)" type="button" class="btn-textlinkLeftIcon md-textlinkleftIcon btn-back" data-bs-dismiss="modal" aria-label="Close"><span class="ph-arrow-left-bold"></span>Back</a>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="member-container">
                        <div class="member-image-box">
                          <img class="lazy" :data-src="team.profile_pic" alt="">
                        </div>
                        <!-- <div class="follow-box">
                          <a :href="team.linkedin_link" type="button" class="btn-follow">Follow us on LinkedIn</a>
                        </div> -->
                      </div>
                    </div>
                    <div class="col-sm-9">
                      <div class="member-content-box">
                        <div class="member-heading">
                          <h4 class="hf_light">{{ team.post_title }}</h4>
                          <p class="hf_light hf_blogbody">{{ team.designation }}</p>
                        </div>
                        <div class="member-content" v-html="team.post_content">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END FULL SCREEN MODAL -->

  </div>
</template>

<script>
export default {
  props: {
    team: { type:Object, default: () => ({})},
  }, 
  mounted(){ 
    // console.log("hi");
    // console.log(this.team);
  }
}

</script>
